import React, { useState, useEffect } from "react";
import Pdf from "../../../../../../Components/Icons/Pdf";
import NewReportTable from "../../../../../../Components/Others/NewReportTable";
import {
  CancelButton,
  SubmitButton,
} from "../../../../../../Components/Utils/Buttons";
import { useFormik } from "formik";
import UseFetchReportData from "../../../../../../Components/Hooks/useFetchReportData";
import axiosInstance from "../../../../../../Services/axiosCommon";
import {
  FormikSelectTwoSmall,
  TwoNEWSmall,
} from "../../../../../../Components/Utils/Select";
import { NuDateSmall } from "../../../../../../Components/Utils/Input";
import UseDropDown from "../../../../../../Components/Hooks/useDropDown";
import NuDateFormat from "../../../../../../Components/Utils/NuDate";
import useFetchMataData from "../../../../../../Components/Hooks/useFetchMataData";
import Xls from "../../../../../../Components/Icons/Xls";
import UseSupplierDropDownNew from "../../../../../../Components/Hooks/useSupplierSearch";
import NuAmount from "../../../../../../Components/Utils/NuAmount";
import Pagination from "../../../../../../Components/Utils/Pagenation";

function PurchaseOrder() {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(
    localStorage.getItem("perPageView") || 20,
  );
  const { data: vendors, setDataSupplier } = UseSupplierDropDownNew(
    "/vendors/drop-down",
    search,
  );

  const [showFilter, setShowFilter] = useState(false);
  const { data: RFQAssignee } = UseDropDown("/user/procurement/drop-down");
  const { value } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "paymentStatus_po",
  );
  // const [filter, setFilter] = useState(false);
  const headers = [
    {
      title: "YPR",
      width: "12.5%",
      field: "prRef",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "PO #",
      width: "12.5%",
      field: "poRef",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Date",
      width: "12.5%",
      field: "date",
      type: "date",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Supplier",
      width: "12.5%",
      field: "vendor",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Currency",
      width: "12.5%",
      field: "currency",
      textAlign: "left",
      type: "text",
      rowAlign: "left",
    },
    {
      title: "Amount",
      width: "12.5%",
      field: "amount",
      textAlign: "left",
      type: "number",
      rowAlign: "left",
    },
    {
      title: "Payment Status",
      width: "12.5%",
      field: "paymentStatus",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Purchaser",
      width: "12.5%",
      field: "purchaser",
      textAlign: "left",
      rowAlign: "left",
    },
  ];

  const [filterProps, setFilterProps] = useState({
    purchaser: "",
    dateFrom: "",
    dateTo: "",
    paymentStatus: "",
    vendorId: "",
  });

  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
    purchaser: "",
    dateFrom: "",
    dateTo: "",
    paymentStatus: "",
    vendorId: "",
  });

  useEffect(() => {
    setParams({ ...params, page: page, per_page: pageCount });
  }, [page, pageCount]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (value) => {
      setParams({
        ...params,
        page: 1,
        purchaser: value.purchaser,
        dateFrom: value.dateFrom,
        dateTo: value.dateTo,
        paymentStatus: value.paymentStatus,
        vendorId: value?.vendorId,
      });
      setPage(1);
    },
  });
  const { data, getData, dataLoading, total, other } = UseFetchReportData(
    "/report/po",
    params,
  );

  function clearFilters() {
    setShowFilter(false);
    formik.resetForm();
    // setFilter(false)
    setPage(1);
    setParams({
      page: 1,
      per_page: pageCount,
      purchaser: "",
      dateFrom: "",
      dateTo: "",
      paymentStatus: "",
      vendorId: "",
    });
  }

  const downloadPDF = async () => {
    try {
      const response = await axiosInstance.get(
        `/report/po/pdf`,
        { params },
        {
          responseType: "blob", // Important to specify the response type as blob
        },
      );

      // Create a Blob from the response
      const pdfBlob = new Blob([response.data], { type: "application/pdf" });

      // Create a link element
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(pdfBlob);
      link.download = `Purchase Order Report ${NuDateFormat({ value: new Date(), format: "DD-MM-YYYY" })}.pdf`; // The filename you want for the downloaded file

      // Append the link to the body (required for Firefox)
      document.body.appendChild(link);

      // Programmatically click the link to trigger the download
      link.click();

      // Clean up and remove the link
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Error downloading the PDF:", error);
    }
  };
  const downloadxlsx = async () => {
    try {
      const response = await axiosInstance.get(`/report/po/xlsx`, {
        params,
        responseType: "blob", // Important to specify the response type as blob
      });

      // Create a Blob from the response
      const xlsxBlob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Create a link element
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(xlsxBlob);
      link.download = `Purchase Order Report ${NuDateFormat({ value: new Date(), format: "DD-MM-YYYY" })}.xlsx`;

      // Append the link to the body (required for Firefox)
      document.body.appendChild(link);

      // Programmatically click the link to trigger the download
      link.click();

      // Clean up and remove the link
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the xlsx:", error);
    }
  };
  return (
    <>
      <div className="w-full h-[calc(100vh-140px)] flex flex-col">
        <div className="w-full items-center gap-x-3 bg-white flex-shrink-0">
          <div className="flex flex-wrap gap-2 justify-between items-center w-full py-1">
            <p className=" font-semibold text-xs 2xl:text-sm pt-1">
              Purchase Order : {total || 0}
            </p>

            <p className=" font-semibold text-[10px] 2xl:text-xs pt-1">
              Total Amount : <NuAmount value={other["totalAmount"] || 0} />
            </p>

            <div className=" flex gap-4 justify-end mt-1">
              <button onClick={downloadPDF}>
                <Pdf />
              </button>
              <button onClick={downloadxlsx}>
                <Xls />
              </button>
            </div>
          </div>

          <form onSubmit={formik.handleSubmit}>
            <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 sm:gap-x-3">
              <NuDateSmall
                label="From Date"
                placeholder="dd/mm/yyyy"
                formik={formik}
                name="dateFrom"
                width="w-full"
              />
              <NuDateSmall
                label="To Date"
                placeholder="dd/mm/yyyy"
                formik={formik}
                name="dateTo"
                width="w-full"
              />
              <TwoNEWSmall
                label="Supplier"
                placeholder="Choose"
                Options={vendors}
                formik={formik}
                name="vendorId"
                setSearch={setSearch}
                FixPosition={false}
                PortalTarget={false}
                width="w-full"
              />
              <FormikSelectTwoSmall
                type="text"
                label="Payment Status"
                placeholder="Choose"
                Options={value}
                formik={formik}
                name="paymentStatus"
                width="w-full"
                FixPosition={true}
                PortalTarget={false}
                isClear={true}
              />
              <FormikSelectTwoSmall
                type="text"
                label="Purchaser"
                placeholder="Choose"
                Options={RFQAssignee}
                formik={formik}
                name="purchaser"
                width="w-full"
                FixPosition={true}
                PortalTarget={false}
                isClear={true}
              />
              <div className=" w-full flex justify-end mb-1.5">
                <div className=" w-full flex justify-end items-end gap-2">
                  <SubmitButton name="Apply" />
                  <CancelButton label="Clear" handleClick={clearFilters} />
                </div>
              </div>
            </div>
          </form>
        </div>

        <div className="w-full flex-grow overflow-y-auto">
          <NewReportTable
            headers={headers}
            data={data}
            dataLoading={dataLoading}
          />
        </div>
        <div className=" w-full h-[40px] text-[#4f4768] flex-shrink-0 bg-white border-t">
          <Pagination
            total={total}
            pageIndex={page}
            setPageIndex={setPage}
            dataCount={pageCount}
            setDataCount={setPageCount}
          />
        </div>
      </div>
    </>
  );
}

export default PurchaseOrder;
